<script lang="ts">
    import CharityProfile from '../../components/admin/charity/charityProfile.svelte';
    export let params: { type: string; id: string };    
</script>

<div class="charity-profile-page">
    <CharityProfile params={params} />
</div>